import { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { MenuAdmin } from "../MenuAdmin"
import { Header } from "../../common/header/Header"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { CommonInput } from "../../common/element/fields/CommonInput"
import { IErrorModel } from "../../../types/error/IErrorModel"
import { IBrockmanBankDto } from "../../../types/brockman/IBrockmanBankDto"
import { CommonFileInput } from "../../common/element/fields/CommonFileInput"
import { IB64File } from "../../../types/IB64File"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { useNavigate, useParams } from "react-router-dom"
import { IInnSuggestion } from "../../../types/inn/IInnSuggestion"
import { ModalConfirm } from "../../common/element/ModalConfirm"
import { CommonFileList } from "../../common/element/fields/CommonFileList"
import { BicPicker } from "../../common/element/fields/BicPicker"
import { IBrockmanDetailDto } from "../../../types/brockman/IBrockmanDetailDto"
import { CONFIG } from "../../../CONFIG"
import { download } from "../../common/CommonHelper"
import { IMG } from "../../common/CONST"
import { DASHBOARD_ROUTE } from "@/routes"
import Button from "@/ui/components/Button"

export const BrockmanAdmin = () => {
  const navigate = useNavigate()
  const params = useParams()

  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [confirmMessage, setConfirmMessage] = useState<IModalMessage>()
  const [brockmanBank, setBrockmanBank] = useState<IBrockmanBankDto>()
  const [brockmanDetail, setBrockmanDetail] = useState<IBrockmanDetailDto>()
  const [errors, setErrors] = useState<IErrorModel>()
  const [files, setFiles] = useState<IB64File[]>([])
  const [isSaving, setSaving] = useState(false)

  const handleIconChange = (file: IB64File) => {
    setBrockmanBank({ ...brockmanBank, avatar: file })
  }

  const handleAdditionalAgreementChange = (file: IB64File) => {
    setBrockmanBank({ ...brockmanBank, additionalAgreement: file })
  }

  const handleBrockmanSignChange = (file: IB64File) => {
    setBrockmanDetail({ ...brockmanDetail, sign: file })
  }

  const handleBrockmanStampChange = (file: IB64File) => {
    setBrockmanDetail({ ...brockmanDetail, stamp: file })
  }

  // const handleInnChange = (inn: IInnSuggestion | undefined) => {
  //   if (inn && inn.suggestions.length > 0) {
  //     setBrockmanBank({ ...brockmanBank, inn: inn.suggestions[0].data.inn })
  //     setBrockmanDetail({
  //       ...brockmanDetail,
  //       name: inn.suggestions[0].value,
  //       beneficiaryAddress: inn.suggestions[0].data.address.unrestricted_value
  //     })
  //   }
  // }

  const handleBicChange = (bic: IInnSuggestion | undefined) => {
    if (bic && bic.suggestions.length > 0) {
      setBrockmanBank({
        ...brockmanBank,
        name: bic.suggestions[0].value,
        bic: bic.suggestions[0].data.bic,
        address: bic.suggestions[0].data.address.unrestricted_value
      })
    }
  }

  const submit = () => {
    if (!brockmanBank) return

    setSaving(true)

    if (brockmanBank.id) {
      const request = brockmanBank
      request.brockmanDetail = brockmanDetail
      TrinityAPI.updateBrockmanBank(
        request,
        response => {
          if (response.status === 200) {
            setBrockmanBank({ ...brockmanBank, id: response.data.id })
            setModalMessage({ title: "Инфо", text: "Информация о банке обновлена" })
          } else {
            setErrors(response.data)
          }
        },
        () => setSaving(false)
      )
    } else {
      const request = brockmanBank
      request.brockmanDetail = brockmanDetail
      TrinityAPI.createBrockmanBank(
        request,
        response => {
          if (response.status === 200) {
            setBrockmanBank({ ...brockmanBank, id: response.data.id })
            setModalMessage({ title: "Инфо", text: "Банк создан" })
          } else {
            setErrors(response.data)
          }
        },
        () => setSaving(false)
      )
    }
  }

  const remove = () => {
    if (!brockmanBank?.id) return
    TrinityAPI.removeBrockman(brockmanBank.id, response => {
      if (response.status === 200) {
        navigate("/")
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка удаления банка" })
      }
    })
  }

  const confirmRemove = (e: boolean | undefined) => {
    if (e) remove()
  }

  const getPreview = (): string | undefined => {
    if (brockmanBank && brockmanBank.avatar?.b64 && brockmanBank.avatar.name) {
      const ext = brockmanBank.avatar.name.split(".").pop()?.toLowerCase()
      if (ext === "jpg" || ext === "jpeg") {
        return "data:image/jpeg;base64," + brockmanBank.avatar.b64
      } else if (ext === "png") {
        return "data:image/png;base64," + brockmanBank.avatar.b64
      } else if (ext === "svg") {
        return "data:image/svg+xml;base64," + brockmanBank.avatar.b64
      } else {
        return undefined
      }
    } else if (brockmanBank && brockmanBank.avatarPath) {
      return `${CONFIG.STORAGE_URL}/${brockmanBank.avatarPath}`
    } else {
      return undefined
    }
  }

  useEffect(() => {
    if (params.id && params.id !== "new") {
      TrinityAPI.getBrockmanBank(params.id, response => {
        if (response.status === 200) {
          setBrockmanBank(response.data)
          setBrockmanDetail(response.data.brockmanDetail)
        } else {
          setModalMessage({ title: "Ошибка!", text: "Ошибка получения банка: " + response.data.message })
        }
      })
    }
  }, [])

  useEffect(() => {
    const newFiles = new Array<IB64File>()
    if (brockmanBank?.avatar) {
      newFiles.push(brockmanBank.avatar)
    }
    if (brockmanBank?.additionalAgreement) {
      newFiles.push(brockmanBank.additionalAgreement)
    }
    if (brockmanDetail?.stamp) {
      newFiles.push(brockmanDetail.stamp)
    }
    if (brockmanDetail?.sign) {
      newFiles.push(brockmanDetail.sign)
    }
    setFiles(newFiles)
  }, [brockmanBank, brockmanDetail])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <ModalConfirm message={confirmMessage} setMessage={() => setConfirmMessage(undefined)} />
      <MenuAdmin active={"dashboard"} />
      <section className="new-contragent">
        <Header />
        <div className="container">
          <h3 className="ui-heading">{brockmanBank?.name && brockmanBank.id ? brockmanBank.name : "Новый банк"}</h3>
          <div className="container-pop-up">
            <div className="form-left">
              <div className="form-block-popup">
                <h4 className="heading-chapter">Информация о банке</h4>
                <BicPicker
                  label={"БИК"}
                  name={"bic"}
                  value={brockmanBank?.bic}
                  errorModel={errors}
                  _callback={handleBicChange}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Название банка"}
                  placeholder={"AO «ALFA-BANK»"}
                  name={"name"}
                  value={brockmanBank?.name}
                  errorModel={errors}
                  _callback={e => setBrockmanBank({ ...brockmanBank, name: e })}
                />
                <CommonInput
                  typeName={"text"}
                  label="Краткое название банка"
                  placeholder="Альфа"
                  name="shortName"
                  maxLength={50}
                  value={brockmanBank?.shortName}
                  errorModel={errors}
                  _callback={e => setBrockmanBank({ ...brockmanBank, shortName: e })}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Адрес банка"}
                  placeholder={"27 Kalanchevskaya str., Moscow, 107078"}
                  name={"address"}
                  value={brockmanBank?.address}
                  errorModel={errors}
                  _callback={e => setBrockmanBank({ ...brockmanBank, address: e })}
                />
              </div>

              <div className="form-block-popup">
                <h4 className="heading-chapter">Информация о получателе</h4>
                <CommonInput
                  typeName={"text"}
                  label={"ИНН получателя"}
                  placeholder={"9909609646"}
                  name={"inn"}
                  value={brockmanBank?.inn}
                  errorModel={errors}
                  _callback={e => setBrockmanBank({ ...brockmanBank, inn: e })}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Расчетный счет получателя"}
                  placeholder={"40807810432180000001"}
                  name={"account"}
                  value={brockmanBank?.account}
                  errorModel={errors}
                  _callback={e => setBrockmanBank({ ...brockmanBank, account: e })}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Имя получателя (Received From в счете)"}
                  placeholder={"Brockman Trade Limited"}
                  name={"brockmanName"}
                  value={brockmanDetail?.name}
                  errorModel={errors}
                  _callback={e => setBrockmanDetail({ ...brockmanDetail, name: e })}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Краткое имя получателя"}
                  placeholder={"BTL"}
                  name={"brockmanShortName"}
                  value={brockmanDetail?.shortName}
                  errorModel={errors}
                  _callback={e => setBrockmanDetail({ ...brockmanDetail, shortName: e })}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Адрес получателя (Beneficiary Address в счете)"}
                  placeholder={"11/F., CAPITAL CENTRE, 151 GLOUCESTER ROAD, WANCHAI 999077, HONG KONG"}
                  name={"brockmanAddress"}
                  value={brockmanDetail?.beneficiaryAddress}
                  errorModel={errors}
                  _callback={e => setBrockmanDetail({ ...brockmanDetail, beneficiaryAddress: e })}
                />
                <CommonInput
                  typeName={"text"}
                  label={"ФИО лица в счете"}
                  placeholder={"ФИО"}
                  name="personName"
                  value={brockmanDetail?.personName}
                  errorModel={errors}
                  _callback={e => setBrockmanDetail({ ...brockmanDetail, personName: e })}
                />
                <CommonInput
                  typeName={"text"}
                  label={"Должность лица в счете"}
                  placeholder={"Должность"}
                  name="personPosition"
                  value={brockmanDetail?.personPosition}
                  errorModel={errors}
                  _callback={e => setBrockmanDetail({ ...brockmanDetail, personPosition: e })}
                />
              </div>
            </div>
            <div className="right-form">
              <div className="form-block-popup">
                <h4 className="heading-chapter">О банке</h4>
                {brockmanBank?.avatar?.b64 || brockmanBank?.avatarPath ? (
                  <ul className="bank-deals-flex" style={{ pointerEvents: "none" }}>
                    <li className="deals-bank-item">
                      <img src={getPreview()} className="deals-bank-img" alt="preview-bank" />
                    </li>
                  </ul>
                ) : (
                  <></>
                )}

                <CommonFileInput
                  label={"Иконка"}
                  placeholder={
                    brockmanBank?.avatarPath || brockmanBank?.avatar ? "Заменить иконку" : "Загрузить иконку"
                  }
                  name={"avatar"}
                  errorModel={errors}
                  _callback={handleIconChange}
                />
                <div className="flex-row-10">
                  <CommonFileInput
                    label={"Бланк доп. соглашения"}
                    placeholder={
                      brockmanBank?.additionalAgreementPath || brockmanBank?.additionalAgreement
                        ? "Заменить"
                        : "Загрузить доп. соглашение"
                    }
                    name={"additionalAgreement"}
                    errorModel={errors}
                    _callback={handleAdditionalAgreementChange}
                  />
                  {brockmanBank?.id ? (
                    <fieldset>
                      <legend>Загруженный бланк</legend>
                      <label className="button-file-dl">
                        <input
                          type="button"
                          multiple={false}
                          className="hidden-object"
                          placeholder="Скачать"
                          onClick={() => download(brockmanBank.id, "BLANK_AGREEMENT")}
                        />
                        <img src={IMG.download_bank} alt="" className="load-file-new" /> Скачать
                      </label>
                    </fieldset>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="flex-row-10">
                  <CommonFileInput
                    label={"Печать"}
                    placeholder={brockmanDetail?.stamp || brockmanDetail?.stampPath ? "Заменить" : "Загрузить"}
                    name={"stamp"}
                    errorModel={errors}
                    _callback={handleBrockmanStampChange}
                  />
                  <CommonFileInput
                    label={"Подпись"}
                    placeholder={brockmanDetail?.sign || brockmanDetail?.signPath ? "Заменить" : "Загрузить"}
                    name={"sign"}
                    errorModel={errors}
                    _callback={handleBrockmanSignChange}
                  />
                </div>
                <CommonFileList files={files} />
              </div>
            </div>
            <div className="flex-row-24">
              <Button onClick={submit} loading={isSaving}>
                Сохранить
              </Button>
              {brockmanBank?.id ? (
                <button
                  className="btn black-btn"
                  onClick={() =>
                    setConfirmMessage({
                      title: "Удалить банк?",
                      text: `Вы действительно желаете удалить банк "${brockmanBank?.name}"`,
                      callbackValue: true,
                      _callback: confirmRemove
                    })
                  }
                >
                  Удалить
                </button>
              ) : (
                <></>
              )}
              <button className="btn grey-btn" onClick={() => navigate(DASHBOARD_ROUTE)}>
                На главную
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
